import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const AppLinkSource = {
  fetchLink: function(id, resource) {
    return axios.get(`${API_BASE}/shopify/query/${id}`, { params: {resource} })
      .then(resp => resp.data)
  }
}

export default AppLinkSource



// WEBPACK FOOTER //
// ./app/sources/AppLinkSource.js